import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "content", "overlay"]

  connect() {
    this._onKeydown = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  async open(event) {
    event.preventDefault()
    event.stopPropagation()
    const url = event.params?.url || event.currentTarget.dataset.modelSlideoutUrlParam || event.currentTarget.href

    this.panelTarget.classList.remove("translate-x-full")
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"

    // Clear previous content before loading new
    this.contentTarget.innerHTML = ""

    try {
      const resp = await fetch(url, { headers: { "Accept": "text/html" } })
      if (!resp.ok) return
      const html = await resp.text()
      const doc = new DOMParser().parseFromString(html, "text/html")
      const frame = doc.querySelector("#model-slideout-content")
      if (frame) {
        this.contentTarget.innerHTML = frame.outerHTML
      }
    } catch (e) {
      console.error("[model-slideout] Failed to load:", e)
    }
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    setTimeout(() => { this.contentTarget.innerHTML = "" }, 300)
  }
}
